import businessAddressesService from "@/services/businessAddresses";
import serviceHandler from "@/helpers/handlers/service";
import { GTM_EVENT_NAME } from "@/enums/gtm-events";

export default {
  name: "GoogleMyBusinessData",
  props: ["businessAddresses", "panelIndex"],
  data() {
    return {
      data: [],
      loaded: false
    };
  },

  async created() {
    await this.fetchData();

    this.loaded = true;
  },

  watch: {
    businessAddresses() {
      this.fetchData();
    },
    panelIndex(newVal, oldVal) {
      this.$gtm.trackCustomEvent({
        event: GTM_EVENT_NAME.LOCATIONS_QUALITY_ITEM_ACTION,
        location_id: this.data[newVal === undefined ? oldVal : newVal]
          .businessAddress.id,
        action: newVal === undefined ? "fold" : "unfold"
      });
    }
  },

  methods: {
    async fetchData() {
      const requests = this.createRequests(this.businessAddresses);
      const response = await Promise.all(requests);

      this.data = response.map((item, i) => {
        return {
          data: item,
          tab: 0,
          selectedChartItem: {},
          paginationMonth: {},
          businessAddress: this.businessAddresses[i]
        };
      });
    },

    createRequests(arr) {
      const requests = [];

      arr.forEach(item => {
        requests.push(
          serviceHandler(
            businessAddressesService.getGoogleMyBusinessAudits({
              businessAddressId: item.id
            })
          )
        );
      });

      return requests;
    }
  },

  render() {
    return this.$scopedSlots.default({
      loading: !this.loaded,
      data: this.data
    });
  }
};
